module.exports = __webpack_public_path__ + "media/images/players/KOZUMA_JINICHIRO-941f9833d051ccfbabb9c50cba5984c3.png";